"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var KEY_CODE_MAP = (_a = {},
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.UP] = [38],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.DOWN] = [40],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.LEFT] = [37],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RIGHT] = [39],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.ENTER] = [13],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.BACK] = [10009, 27],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.FF] = [417],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RW] = [412],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PLAY] = [415],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PAUSE] = [19],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.STOP] = [413],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RED] = [403],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.GREEN] = [404],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.YELLOW] = [405],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.BLUE] = [406],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.INFO] = [457],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[1]] = [49],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[2]] = [50],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[3]] = [51],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[4]] = [52],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[5]] = [53],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[6]] = [54],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[7]] = [55],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[8]] = [56],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[9]] = [57],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[0]] = [48],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.CHANNEL_UP] = [427],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.CHANNEL_DOWN] = [428],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_1] = [403],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_2] = [406],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_3] = [404],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_4] = [412],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_5] = [417],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_6] = [405],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_9] = [403],
    _a);
var REGISTER_KEYS = [
    'MediaPause',
    'MediaPlay',
    'MediaPlayPause',
    'MediaFastForward',
    'MediaRewind',
    'MediaStop',
    'ColorF0Red',
    'ColorF1Green',
    'ColorF2Yellow',
    'ColorF3Blue',
    'ChannelUp',
    'ChannelDown',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
];
var PREVENT_DEFAULT = new Set([13, 65376, 27]);
var TizenInput = (function (_super) {
    __extends(TizenInput, _super);
    function TizenInput(window) {
        var _this = _super.call(this, window) || this;
        _this.keyCodeMap = KEY_CODE_MAP;
        _this.preventDefault = PREVENT_DEFAULT;
        REGISTER_KEYS.forEach(function (key) {
            window.tizen.tvinputdevice.registerKey(key);
        });
        return _this;
    }
    return TizenInput;
}(client_lib_js_player_addons_common_player_1.Input));
exports.TizenInput = TizenInput;
